<div
  class="container"
  [class.loading]="loyaltyProgramLoading$ | async"
  [class.checkout-linked-account-top]="linkedAccountPosition === 'top'"
  [class.collapsible-transfer-amount-form]="collapsibleTransferAmountForm">
  <rd-shared-breadcrumb
    *ngIf="shouldRenderCheckoutBreadcrumb"
    [breadcrumbText]="'transfer_v2.checkout.back_to_programs' | translate"
    [redirectURL]="'/transfer/programs'"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'">
  </rd-shared-breadcrumb>

  <div class="banner-section" *ngIf="shouldRenderCheckoutBanner">
    <rd-tcv2-checkout-banner
      [loading]="loyaltyProgramLoading$ | async"
      [loyaltyProgram]="loyaltyProgram$ | async">
    </rd-tcv2-checkout-banner>
  </div>

  <div class="desktop-container">
    <div class="desktop-left">
      <rd-tcv2-checkout-terms-list-wrapper
        [loading]="loyaltyProgramLoading$ | async"
        [loyaltyProgram]="loyaltyProgram$ | async">
      </rd-tcv2-checkout-terms-list-wrapper>
    </div>

    <div class="desktop-right">
      <rd-tcv2-checkout-program-description
        class="mx-4 lg:ml-5"
        [loading]="loyaltyProgramLoading$ | async"
        [loyaltyProgram]="loyaltyProgram$ | async">
      </rd-tcv2-checkout-program-description>

      <rd-tcv2-checkout-form
        [formData]="checkoutFormData$ | async"
        [disabled]="shouldDisableForm"
        [isLoggedIn]="isLoggedIn"
        [loyaltyProgram]="loyaltyProgram$ | async"
        (submitForm)="submitCheckoutFormData($event)"
        [linkedAccount]="loyaltyProgramMembership$ | async"
        [loyaltyProgramOrMembershipsLoading]="
          loyaltyProgramOrMembershipsLoading$ | async
        "></rd-tcv2-checkout-form>
    </div>
  </div>
</div>
